module.exports = __webpack_public_path__ + "static/media/2 (31).5a7f8d67.jpg";